import { render, staticRenderFns } from "./CareCommunityEditor.vue?vue&type=template&id=695dff4c&scoped=true&"
import script from "./CareCommunityEditor.vue?vue&type=script&lang=js&"
export * from "./CareCommunityEditor.vue?vue&type=script&lang=js&"
import style0 from "./CareCommunityEditor.vue?vue&type=style&index=0&id=695dff4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695dff4c",
  null
  
)

export default component.exports